import { render } from "./IconPlay.vue?vue&type=template&id=6247402c"
const script = {}

import exportComponent from "/Users/nazikban/projects/credit-west-second/packages/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"IconPlay.vue"]])

export default __exports__